import script from "./VehicleReports.vue?vue&type=script&setup=true&lang=js"
export * from "./VehicleReports.vue?vue&type=script&setup=true&lang=js"

import "./VehicleReports.vue?vue&type=style&index=0&id=0dfd7f41&lang=css"

const __exports__ = script;

export default __exports__